import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router";

import { LayoutContext } from "../layout/";

import Loader from "../loader";
import { getEndpoint } from "../helper";

export default function ProductSpec({ }) {
    const { setPageTitle } = useContext(LayoutContext);

    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const { id } = useParams();

    useEffect(() => {
        setPageTitle('مشخصات');

        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(getEndpoint(`/api/android/spec/getby?productId=${id}`), { signal });
                const json = await response.json();
                setData(json.data);

            } catch (err) {
                if (err.name !== "AbortError") setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

        return () => controller.abort();
    }, []);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <div style={{ backgroundColor: '#f5f5f5' }}>
            <div className='bc-w m-2 br-2 p-4'>
                {data.map(x => (
                    <div className='d-f ai-c'>
                        <div className='w-4/12' style={{ color: '#757575' }} children={x.title} />
                        <div className='w-8/12 bbw-1' style={{ borderColor: '#eeeeee' }} children={x.value} />
                    </div>
                ))}
            </div>
        </div>
    );
}